import React from 'react'
import { dateToString } from '../../../../utils/dateFormatting'

export default ({ active, payload, label }) => {
    if (active) {
        const formattedLabel = dateToString(label)
        return (
            <div className="recharts-default-tooltip customTooltip">
                <p className="recharts-tooltip-label customTooltipLabel">{formattedLabel}</p>
                <ul className="recharts-tooltip-item-list customTooltipList">
                    {payload && payload.map((x, idx) =>
                        x.name !== 'NoTooltipItem' ? (
                            <li style={{color: x.color}} key={idx}>
                                <span className="customTooltipItemName">
                                    {x.name}
                                </span>
                                <span> : </span>
                                <span className="customTooltipItemValue">
                                    {Math.round(x.value * 100) / 100}
                                </span>
                            </li>
                        ) : null
                    )}
                </ul>
            </div>
        )
    }
    return null
}
